module.exports = __webpack_public_path__ + "img/WX_PAY.c22571ba.png";